var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1729038642457,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 27392,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M548.8 1024h-73.6C214.4 1024 0 809.6 0 548.8v-73.6C0 212.8 214.4 0 475.2 0h73.6C811.2 0 1024 212.8 1024 475.2v73.6C1024 809.6 809.6 1024 548.8 1024z",
    fill: "#E55590",
    "p-id": 27393
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M510.4 377.6c-75.2 0-136 60.8-136 136s60.8 136 136 136 136-60.8 136-136-60.8-136-136-136z m0 224c-49.6 0-88-40-88-88s40-88 88-88 88 40 88 88-40 88-88 88z m262.4-204.8c0-83.2-65.6-147.2-147.2-147.2 0 0-59.2-1.6-115.2-1.6s-113.6 1.6-113.6 1.6c-83.2 0-150.4 67.2-150.4 150.4 0 0-1.6 52.8-1.6 107.2 0 59.2 1.6 120 1.6 120 0 83.2 67.2 150.4 150.4 150.4 0 0 52.8 1.6 107.2 1.6 59.2 0 121.6-1.6 121.6-1.6 83.2 0 147.2-65.6 147.2-147.2 0 0 1.6-59.2 1.6-116.8 0-59.2-1.6-116.8-1.6-116.8z m-46.4 222.4c0 67.2-41.6 110.4-110.4 110.4 0 0-62.4 1.6-110.4 1.6-44.8 0-99.2-1.6-99.2-1.6-67.2 0-112-43.2-112-112 0 0-1.6-60.8-1.6-108.8 0-44.8 1.6-102.4 1.6-102.4 0-67.2 43.2-110.4 112-110.4 0 0 57.6-1.6 104-1.6s105.6 1.6 105.6 1.6c67.2 0 110.4 41.6 110.4 110.4 0 0 1.6 59.2 1.6 104 0 48-1.6 108.8-1.6 108.8z m-73.6-280c-17.6 0-32 14.4-32 32s14.4 32 32 32 32-14.4 32-32-14.4-32-32-32z",
    fill: "#FFFFFF",
    "p-id": 27394
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.262d513b5ba4f69113a232b159136e0c.svg";
export { ForwardRef as ReactComponent };